export default "__VITE_ASSET__W8Cjvi2___"